import { Box, Typography, Stack } from "@mui/material";

const rules = [
  "Winners will be announced on 25th October at 3:00 PM.",
  "You must be present at the venue to claim your prize.",
  "If multiple participants get the correct answers, the winner will be decided through a lucky draw.",
  "The organisers' decision will be final.",
];

const keyframes = `
@keyframes popIn {
  0% { transform: scale(0.5); opacity: 0; }
  70% { transform: scale(1.12); opacity: 1; }
  100% { transform: scale(1); }
}
@keyframes fadeUp {
  from { transform: translateY(18px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}
@keyframes floaty {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
}
`;

const purple = {
  dark: "#4a148c",
  main: "#6a1b9a",
  mid: "#7e57c2",
  light: "#ede7f6",
  soft: "#f8f4ff",
  border: "#d1c4e9",
};

function ContestThankYou({ isWinner }) {
  return (
    <Box
      sx={{
        minHeight: "90vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        padding: { xs: "16px 12px", sm: "32px 16px" },
       
      }}
    >
      <style>{keyframes}</style>

      <Box
        sx={{
          width: "100%",
          maxWidth: 560,
          background: "#fff",
          borderRadius: "24px",
          boxShadow: "0 14px 40px rgba(106,27,154,0.18)",
          overflow: "hidden",
          animation: "fadeUp 0.6s ease both",
        }}
      >
       
        <Box
          sx={{
            position: "relative",
            background: `linear-gradient(135deg, ${purple.dark}, ${purple.mid})`,
            color: "#fff",
            textAlign: "center",
            padding: { xs: "32px 20px 40px", sm: "40px 24px 48px" },
            overflow: "hidden",
          }}
        >
          {/* decorative circles */}
          <Box
            sx={{
              position: "absolute",
              top: -40,
              right: -40,
              width: 140,
              height: 140,
              borderRadius: "50%",
              background: "rgba(255,255,255,0.10)",
            }}
          />
          <Box
            sx={{
              position: "absolute",
              bottom: -50,
              left: -30,
              width: 120,
              height: 120,
              borderRadius: "50%",
              background: "rgba(255,255,255,0.08)",
            }}
          />

          <Box
            sx={{
              position: "relative",
              width: 88,
              height: 88,
              margin: "0 auto",
              borderRadius: "50%",
              background: "rgba(255,255,255,0.18)",
              border: "2px solid rgba(255,255,255,0.45)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 46,
              animation: "popIn 0.7s ease both, floaty 3s ease-in-out 0.8s infinite",
            }}
          >
            {isWinner ? "🎉" : "🌟"}
          </Box>

          <Typography
            sx={{
              position: "relative",
              fontSize: { xs: 20, sm: 24 },
              fontWeight: 800,
              mt: 2,
              lineHeight: 1.3,
            }}
          >
            Thank you for participating in the Rajasthani Bazaar Contest!
          </Typography>

          
        </Box>

       
        <Box sx={{ padding: { xs: "22px 16px 28px", sm: "28px 24px 32px" } }}>
          {isWinner ? (
            <>
             
              <Box
                sx={{
                  background: purple.soft,
                  border: `1px solid ${purple.border}`,
                  borderRadius: "6px",
                  padding: "16px",
                  textAlign: "center",
                  mb: 2.5,
                }}
              >
                <Typography
                  sx={{ fontWeight: 800, fontSize: 17, color: purple.main }}
                >
                  You are now eligible for the contest!
                </Typography>
                <Typography sx={{ color: "#555", fontSize: 14, mt: 0.6 }}>
                  You stand a chance to win exciting{" "}
                  <b style={{ color: purple.main }}>cash prizes</b> 💰
                </Typography>
              </Box>

              {/* Announcement card */}
              <Box
                sx={{
                  background: `linear-gradient(135deg, ${purple.main}, ${purple.mid})`,
                  borderRadius: "16px",
                  padding: "18px 16px",
                  textAlign: "center",
                  color: "#fff",
                  mb: 3,
                  boxShadow: "0 8px 20px rgba(106,27,154,0.25)",
                }}
              >
                <Typography
                  sx={{ fontSize: 13, opacity: 0.9, letterSpacing: 1 }}
                >
                  🏆 WINNER ANNOUNCEMENT
                </Typography>
                <Typography sx={{ fontWeight: 800, fontSize: 22, mt: 0.5 }}>
                  25th October 2026
                </Typography>
                <Typography sx={{ fontWeight: 600, fontSize: 16, opacity: 0.95 }}>
                  at 3:00 PM
                </Typography>
              </Box>

              {/* Rules */}
              <Typography
                sx={{
                  fontWeight: 800,
                  fontSize: 16,
                  color: purple.dark,
                  mb: 1.5,
                }}
              >
                 Contest Rules
              </Typography>
              <Stack spacing={1.2}>
                {rules.map((rule, i) => (
                  <Box
                    key={i}
                    sx={{
                      display: "flex",
                      gap: 1.4,
                      alignItems: "flex-start",
                      background: purple.soft,
                      borderRadius: "12px",
                      padding: "10px 12px",
                    }}
                  >
                    <Box
                      sx={{
                        minWidth: 26,
                        height: 26,
                        borderRadius: "50%",
                        background: purple.main,
                        color: "#fff",
                        fontSize: 13,
                        fontWeight: 700,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {i + 1}
                    </Box>
                    <Typography
                      sx={{ fontSize: 14, color: "#444", lineHeight: 1.5 }}
                    >
                      {rule}
                    </Typography>
                  </Box>
                ))}
              </Stack>

              <Box
                sx={{
                  textAlign: "center",
                  mt: 3.5,
                  p: 1.5,
                  borderRadius: "14px",
                  border: `2px dashed ${purple.border}`,
                }}
              >
                <Typography
                  sx={{ fontWeight: 800, fontSize: 20, color: purple.main }}
                >
                  Good luck! 
                </Typography>
              </Box>
            </>
          ) : (
            <>
              {/* Not eligible message */}
              <Box sx={{ textAlign: "center", mb: 3 }}>
                <Typography
                  sx={{
                    fontSize: 18,
                    fontWeight: 700,
                    color: purple.dark,
                    mb: 1,
                  }}
                >
                  We truly appreciate your participation
                </Typography>
                <Typography
                  sx={{ fontSize: 14.5, color: "#555", lineHeight: 1.7 }}
                >
                  Thank you for taking the time to join the quiz. Not all
                  answers were correct this time, so you are not part of this
                  round's prize draw. We hope you enjoyed it and learned
                  something new about Chennai's history!
                </Typography>
              </Box>

              {/* Encouragement card */}
              <Box
                sx={{
                  background: purple.soft,
                  border: `1px solid ${purple.border}`,
                  borderRadius: "16px",
                  padding: "18px 16px",
                  textAlign: "center",
                  mb: 2.5,
                }}
              >
                <Typography
                  sx={{ fontWeight: 800, fontSize: 17, color: purple.main }}
                >
                  Better luck next time! 💪
                </Typography>
                {/* <Typography
                  sx={{ fontSize: 13.5, color: "#666", mt: 0.8, lineHeight: 1.6 }}
                >
                  Keep an eye out for more contests and exciting offers at the
                  Rajasthani Bazaar.
                </Typography> */}
              </Box>

              {/* Closing banner */}
              <Box
                sx={{
                  background: `linear-gradient(135deg, ${purple.main}, ${purple.mid})`,
                  borderRadius: "14px",
                  padding: "14px 16px",
                  textAlign: "center",
                  color: "#fff",
                }}
              >
                <Typography sx={{ fontWeight: 700, fontSize: 15 }}>
                  Thank you for being part of the celebration! 🎊
                </Typography>
              </Box>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default ContestThankYou;